import { useEffect, useState } from 'react';

/**
 * Single hook that fetches `/brand-data.json` — the canonical brand
 * single-source-of-truth — and keeps the result cached across the app.
 *
 * All components that render colours, typography, voice rules, etc.
 * should call this hook so they automatically stay in lock-step with
 * the markdown files generated by `/app/scripts/generate_brand_md.py`.
 */

let _cache = null;
let _inflight = null;

export function useBrandData() {
  const [data, setData] = useState(_cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (_cache) {
      setData(_cache);
      return;
    }
    if (!_inflight) {
      _inflight = fetch('/brand-data.json')
        .then((r) => {
          if (!r.ok) throw new Error(`brand-data.json: ${r.status}`);
          return r.json();
        })
        .then((json) => {
          _cache = json;
          return json;
        });
    }
    _inflight.then(setData).catch(setError);
  }, []);

  return { data, error, loading: !data && !error };
}
